import React from 'react';

function StatusCard({ title, value, tone = 'neutral', hint }) {
    return (
        <div className={`aleta-billing-status-card ${tone}`}>
            <div className="aleta-billing-status-title">{title}</div>
            <div className="aleta-billing-status-value">{value}</div>
            {hint ? <div className="aleta-billing-status-hint">{hint}</div> : null}
        </div>
    );
}

export default StatusCard;
